/* Material */
import Button from '@mui/material/Button'

/* Material-Icons */
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import FavoriteIcon from '@mui/icons-material/Favorite'

/* Redux */
import Redux from './Redux'

/* Types */
import { ButtonProps } from '@mui/material'

interface Props extends ButtonProps {
  /** Die ausgewählten Attribute */
  pId: number
  pKey: string
}

/**
 * Ein Favoriten-Button
 * @param pId Die Produkt-ID
 * @param pKey Der Produkt-Key
 * @param options Die ausgewählten Optionen
 * @returns Favoriten-Button
 */
const AddToFavButton: React.FC<Props> = ({ pId:id, pKey:key, ...props }) => {

  const { items, addItem, removeItem } = Redux()

  const saved = items[key]
  const item = { id, key }

  return <Button {...props}
    onClick={()=> !saved ? addItem(item) : removeItem(key) }
    title="Zu meiner Wunschliste hinzufügen"
  >
    { !saved
      ? <FavoriteBorderIcon />
      : <FavoriteIcon />
    }
  </Button>
  
}

export default AddToFavButton
